import { Button } from 'antd';
import classnames from 'classnames';
import { FiTrash2 } from 'react-icons/fi';

import { getFileFormatLabel, getFileKind } from '~/shared/helpers/file-presentation-helpers';
import { useTypedTranslation } from '~/shared/hooks';
import type { FileType } from '~/shared/types/file-type';

import './file-field.scss';

type FileFieldPropsType = {
  withDeleteButton?: boolean;
  withFileName?: boolean;
  fieldIndex?: number;
  data: FileType;
  onDelete?: (fieldIndex: string) => void;
};

const FileField = ({
  data,
  withDeleteButton = false,
  withFileName,
  isNoLink = true,
  onClick,
  fieldIndex,
  onDelete,
}: FileFieldPropsType) => {
  const t = useTypedTranslation(['text']);
  const formatLabel = getFileFormatLabel(data);
  const fileKind = getFileKind(data);

  const fileKindLabel = {
    image: t('text.file-kind-image'),
    pdf: t('text.file-kind-pdf'),
    text: t('text.file-kind-text'),
    presentation: t('text.file-kind-presentation'),
    spreadsheet: t('text.file-kind-spreadsheet'),
    document: t('text.file-kind-document'),
    audio: t('text.file-kind-audio'),
    video: t('text.file-kind-video'),
    archive: t('text.file-kind-archive'),
    link: t('text.file-kind-link'),
    file: t('text.file-kind-file'),
  }[fileKind];

  const content = (
    <>
      <span className="file-field__file-kind">{fileKindLabel}</span>
      <span
        className={classnames(
          'file-field__file-type',
          'file-field__file-unknown-type',
          `file-field__file-type--${fileKind}`,
        )}
      >
        {formatLabel}
      </span>
      {!withFileName && (
        <span className={classnames('file-field__file-name', 'link', 'link--underlined')}>{data?.name}</span>
      )}
    </>
  );

  return (
    <div onClick={onClick ?? null} className="file-field">
      {typeof fieldIndex === 'number' && <span className="file-field__link-block-counter">{fieldIndex + 1}</span>}
      {isNoLink ? (
        content
      ) : (
        <a href={data.path} target="_blank" className={classnames('file-field__link')} rel="noreferrer">
          {content}
        </a>
      )}

      {withDeleteButton && (
        <Button
          className="file-field__button"
          variant="outlined"
          onClick={(event) => {
            event.preventDefault();
            event.stopPropagation();
            onDelete?.(fieldIndex);
          }}
        >
          <FiTrash2 className="file-field__delete-button" />
        </Button>
      )}
    </div>
  );
};

export default FileField;
